<div class="row">
  <div class="col-lg-12">
    <div id="basic-example" role="application" class="wizard clearfix">
      <div class="steps clearfix">
        <ul role="tablist">
          <li
            class="first"
            *ngFor="let step of steps; let i = index"
            [ngClass]="{ current: i === currentStep }">
            <a
              ><span class="current-info">current step: </span
              ><span class="number">{{ step.index }}</span> {{ step.title }}</a
            >
          </li>
        </ul>
      </div>

      <div class="content">
        <ng-container *ngIf="currentStep === 0">
          <app-step-one></app-step-one>
        </ng-container>

        <ng-container *ngIf="currentStep === 1">
          <app-step-two></app-step-two>
        </ng-container>

        <ng-container *ngIf="currentStep === 2">
          <app-step-three></app-step-three>
        </ng-container>

        <ng-container *ngIf="currentStep === 3">
          <app-step-four></app-step-four>
        </ng-container>

        <ng-container *ngIf="currentStep === 4">
          <app-step-five></app-step-five>
        </ng-container>

        <ng-container *ngIf="currentStep === 5">
          <app-step-six></app-step-six>
        </ng-container>

        <ng-container *ngIf="currentStep === 6">
          <app-step-seven></app-step-seven>
        </ng-container>
      </div>

      <div class="actions clearfix">
        <ul role="menu" aria-label="Pagination">
          <li *ngIf="currentStep >= 1">
            <a (click)="previousStep()" role="menuitem" style="cursor: pointer"
              >Previous Step</a
            >
          </li>
          <li *ngIf="currentStep < 6">
            <a (click)="nextStep()" role="menuitem" style="cursor: pointer"
              >Next Step</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
